import $ from "jquery";
import moment from "moment";
import { csl, u_ } from "@pressmedia/webappbase";

/**
 * パラメータの値とparamInfoの内容に従って、$elementを生成する関数
 *
 * @param {Object} item
 * @param {String} pk
 * @param {Object} pi
 * @param {String} className
 * @returns $Object
 */
function _createElementByParamInfo(item, pk, pi, className) {
	if( !u_.hasProperty(item, pk) ) {
		return undefined;
	}
	
	const module = this.container.module;
	const pd = item[pk];
	
	switch(pi.inpType) {
		case "radio":
		case "flg": {
			return $("<span/>").addClass(`${pk}-${pd} ${className}`).html(pi.dataOption[pd]);
		}
		
		case "checkbox": {
			return Array.isArray(pd) ? $.fn.append.apply(
				$("<div/>"),
				pd.map(data => $("<span/>").addClass(`${pk}-${data} ${className}`).html(
					pi.dataOption[data]
				))
			).children() : undefined;
		}
		
		case "select": {
			const $elm = $("<span/>").addClass(`${pk}-${pd} ${className}`).text(
				pi.dataOption[pd]
			);
			!!pi.unit && $elm.append( $("<span/>").addClass("unit").text(pi.unit) );
			return $elm;
		}
		
		case "date": {
			const date = moment(pd);
			return $("<span/>").addClass(className).text(
				date.format(module.config.dateFormat)
			);
		}
		
		case "datetime": {
			const date = moment(pd);
			return $("<span/>").addClass(className).append(
				$("<span/>").addClass("day").text( date.format(module.config.dateFormat) ),
				$("<span/>").addClass(
					`time${date.format("Hm") === "00" ? " is-zero-time" : ""}`
				).text( date.format(module.config.timeFormat) )
			);
		}
		
		case "period": {
			u_.isBoolean(pi.hasTime) || (pi.hasTime = true);
			const children = [];
			const start = !!pd.start && moment(pd.start);
			
			if(start) {
				const $elm = $("<span/>").attr("data-period", "start").append(
					$("<span/>").addClass("day").text( start.format(module.config.dateFormat) )
				).addClass(pi.hasTime ? "type-datetime" : "type-date");
				
				pi.hasTime && $elm.append(
					$("<span/>").addClass("time").text( start.format(module.config.timeFormat) )
				);
				
				children.push($elm);
			}
			
			if(pd.end) {
				const end = moment(pd.end);
				const $elm = $("<span/>").attr("data-period", "end").append(
					$("<span/>").addClass("day").text( end.format(module.config.dateFormat) )
				).addClass(pi.hasTime ? "type-datetime" : "type-date");
				
				pi.hasTime && $elm.append(
					$("<span/>").addClass("time").text( end.format(module.config.timeFormat) )
				);
				
				children.push($("<span/>").addClass("period-splitter"), $elm);
				
				if( start && start.isSame(end, "day") ) {
					className += start.isSame(end) ? " is-same-date" : " is-same-day";
				}
			}
			
			return !children.length ? undefined : $("<span/>").addClass(className).append(
				...children
			);
		}
		
		case "file": {
			return Array.isArray(pd) ? $.fn.append.apply(
				$("<div/>"),
				pd.map((data, i) => {
					const strId = `${pk}${item.itemId}_${String(i + 1)}`;
					const src = `${module.config.fileDir}/${pi.dataType}/${strId}.${data.ext}`;
					
					switch(pi.dataType) {
						case "img": {
							const $container = $("<div/>");
							
							this.imagePromiseList.push(
								new Promise( resolve => module.app.imgPreload(
									`${src}?${moment().valueOf()}`,	// no cache
									(err, src, img, e) => {
										if(err) {
											$container.addClass("can-not-load");
											resolve();
											return false;
										}
										
										const org = {
											height: img.height,
											width: img.width
										};
										
										const attr = {
											"data-original-height": org.height,
											"data-original-width": org.width,
											"data-ratio": String(org.height / org.width)
										};
										
										// [shape]
										if(org.height < org.width) {
											attr["data-shape"] = "horizontally";
										} else
										if(org.height > org.width) {
											attr["data-shape"] = "vertically";
										} else {
											attr["data-shape"] = "square";
										}
										
										img.alt = !data.name ? strId : data.name;
										
										// add to DOM tree.
										const $img = $(img).clone().prependTo($container);
										
										// [fit to]
										const ratio =  $container.height() / $container.width();
										attr["data-fit-to"] = (attr["data-ratio"] < ratio) ? "h" : "w";
										
										// [zoom]
										if(org.height < img.height || org.width < img.width) {
											attr["data-zoom"] = "in";
										} else
										if(org.height > img.height || org.height > img.height) {
											attr["data-zoom"] = "out";
										} else {
											attr["data-zoom"] = "eq";
										}
										
										$img.attr(attr);
										resolve();
									}
								) )
							);
							
							// caption
							!!data.name && $container.append(
								$("<span/>").addClass("caption").text(data.name)
							);
							
							return $container;
						}
						
						case "pdf": {
							let txt = !!data.name ? data.name : "PDFファイル";
							if(module.config.showPdfSize && data.size) {
								const kb = data.size / 1024;
								if(kb > 1024) {
									const mb = kb / 1024;
									if(mb > 1024) {
										const gb = mb / 1024;
										const sizeDisp = Math.round(gb * 10) / 10;
										txt += ` (${sizeDisp}GB)`;
									} else {
										const sizeDisp = String(Math.round(mb * 10) / 10);
										txt += ` (${sizeDisp}MB)`;
									}
								} else {
									const sizeDisp = String(Math.round(kb * 10) / 10);
									txt += ` (${sizeDisp}KB)`;
								}
							}
							
							return $("<div/>").append(
								$("<a/>").attr({
									target: "_blank",
									href: src
								}).append( $("<span/>").text(txt) )
							);
						}
						
						case "video": {
							const $container = $("<div/>");
							
							$("<video/>").attr({
								src: src,
								preload: "metadata",
								controls: ""
							}).appendTo($container);
							
							// caption
							!!data.name && $container.append(
								$("<span/>").addClass("caption").text(data.name)
							);
							
							return $container;
						}
						
						case "office": {
							const pInfo = u_.pathInfo(src);
							const txt = !data.name ? pInfo.basename : data.name;
							const ext = !u_.pathInfo(txt).extension ? `.${pInfo.extension}` : "";
							
							return $("<div/>").append(
								$("<a/>").attr({
									target: "_blank",
									href: src,
									download: `${txt}${ext}`
								}).append( $("<span/>").text(txt) )
							);
						}
						
						default: {
							csl.warn(`undefined file's dataType: ${pi.dataType}`, data);
						} break;
					}
				})
			).children().addClass(`${className} type-${pi.dataType}`) : undefined;
		}
		
		case "array": {
			if( Array.isArray(pd) && u_.isObject(pi.dataParams) ) {
				return $.fn.append.apply(
					$("<div/>"),
					pd.map((data, i) => $.fn.append.apply(
						$("<div/>").addClass(className).attr("data-index", i),
						Object.keys(data).map(k => {
							if(pi.dataParams[k]) {
								return this._createElementByParamInfo(
									data,
									k,
									pi.dataParams[k],
									""
								).attr("data-key", k);
							}
						})
					))
				).children();
			}
			
			return undefined;
		}
		
		case "link": {
			return Array.isArray(pd) ? $.fn.append.apply(
				$("<div/>"),
				pd.map( (data, i) => $("<a/>").addClass(className).attr({
					"href": data.url,
					"target": "_blank",
					"rel": "noopener noreferrer",
					"data-index": i
				}).append(
					$("<span/>").text( data.name || decodeURIComponent(data.url) )
				) )
			).children() : undefined;
		}
		
		case "textarea": {
			return $(`<${!pi.isBlock ? "p" : "div"}/>`).addClass(className).html(
				// 改行を置換
				$.parseHTML( u_.textareaParse(pd, pi.isBlock) )
			);
		}
		
		case "html": {
			return $("<div/>").addClass(className).html( $.parseHTML(pd) );
		}
		
		case "wysiwyg": {
			const $editor = $("<div/>").addClass("ql-editor").html( $.parseHTML(pd) );
			$editor.find("img").each((i, img) => {
				this.imagePromiseList.push( new Promise(resolve => {
					if(img.complete) {
						resolve();
					} else {
						$(img).on("load", e => resolve()).on("error", e => resolve());
					}
				}) );
			});
			
			return $("<div/>").addClass(`${className} ${module.wysiwyg.boxClass}`).append(
				$("<div/>").addClass("ql-container").append(
					$editor
				)
			);
		}
		
		case "password": {
			return $("<em/>").addClass(className).text("パスワードは表示できません");
		}
		
		default: {	// text, nubmer
			const $elm = $("<span/>").addClass(className).text(pd);
			!!pi.unit && $elm.append( $("<span/>").addClass("unit").text(pi.unit) );
			return $elm;
		}
	}
}

export default _createElementByParamInfo;
